import { atom, useAtom } from "react-atomic-state";

const userProfile = atom(null);
export const setUserProfile= (profile) => {
  userProfile.set(profile);
};
export const useUserProfile = () => useAtom(userProfile);

